import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import ActorHairStyle from '../../../domain/entities/ActorHairStyle';

export default function reducer(
  state: {[key: number]: ActorHairStyle} = {},
  action: AnyAction,
): {[key: number]: ActorHairStyle} {
  switch (action.type) {
    case Types.IndexActorHairStylesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: ActorHairStyle}, record: ActorHairStyle) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    default:
      return state;
  }
}
